import { Reveal } from "./Reveal";
import { PROCESS, IMAGES } from "@/lib/content";

export const Process = () => (
  <section id="process" data-testid="process" className="bg-[#FBF9F6] py-24 md:py-40">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="eyebrow">03 — How it's made</span>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[1.02]">
              From first sketch to <span className="italic text-[#8C7A6B]">final oil.</span>
            </h2>
            <p className="text-[#5C5A56] mt-6 max-w-md leading-relaxed">
              A commission is a relationship. Ours follows four unhurried movements — and continues long after delivery.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative overflow-hidden aspect-[4/3] mt-12 border border-[#E5E0D8]">
              <img src={IMAGES.process} alt="Craftsmanship process" className="img-cover" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.06}>
              <div className="border-t border-[#E5E0D8] py-9 md:py-11 grid grid-cols-[70px_1fr] gap-6 group">
                <span className="font-serif text-3xl md:text-4xl text-[#8C7A6B] group-hover:translate-x-1 transition-transform duration-500">{p.n}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl tracking-tight mb-2">{p.title}</h3>
                  <p className="text-[#5C5A56] leading-relaxed max-w-xl">{p.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
